import * as io from "io-ts";
import createGlobalState from "@ui/lib/createGlobalState";

const useSuspectedFailuresInExplanation = createGlobalState({
  key: "confirmedFailureInExplanation",
  storage: "session",
  type: io.boolean,
  defaultValue: false,
  scoped: true,
});

export default useSuspectedFailuresInExplanation;
